import { render, staticRenderFns } from "./ProductsItem.vue?vue&type=template&id=1fc870fb&"
import script from "./ProductsItem.vue?vue&type=script&lang=js&"
export * from "./ProductsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports